'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var React = require('react');

/**
 *
 */ const Trigger = ({ children })=>{
    // const { openAction } = usePopoverInternalVars();
    const ForwardedChild = /*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ React.cloneElement(children, {
            ...props,
            innerRef: ref
        }));
    ForwardedChild.displayName = "ForwardedChild";
    // if (openAction === "hover") {
    //   return <Anchor>{children}</Anchor>;
    // }
    return /*#__PURE__*/ jsxRuntime.jsx(index.Trigger, {
        asChild: true,
        children: /*#__PURE__*/ jsxRuntime.jsx(ForwardedChild, {})
    });
};
Trigger.displayName = "Popover.Trigger";

exports.Trigger = Trigger;
//# sourceMappingURL=Trigger.web.cjs.map
